var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEndHeader = function SvgEndHeader(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 228,
    height: 134,
    fill: "none",
    viewBox: "0 0 228 134",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M122.865 63.367h-14.314v63.483h14.314z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M139.08 119.683H92.353V134h46.727zM115.7 73.967c-20.43 0-36.978-16.55-36.978-36.984V0h73.956v36.983c0 20.434-16.548 36.984-36.978 36.984"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA4F57",
    d: "M152.678 36.983c0 20.434-16.565 36.984-36.978 36.984-20.414 0-36.978-16.55-36.978-36.984z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M32.162 82.533H21.73V128.8h10.432z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M43.977 123.567H9.932V134h34.045zM26.946 90.25C12.065 90.25 0 78.183 0 63.3V36.35h53.892V63.3c0 14.883-12.065 26.95-26.946 26.95"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA4F57",
    d: "M53.892 63.3c0 14.883-12.065 26.95-26.946 26.95S0 78.183 0 63.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M206.27 82.533h-10.432V128.8h10.432z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M218.068 123.567h-34.045V134h34.045zM201.054 90.25c-14.881 0-26.946-12.067-26.946-26.95V36.35H228V63.3c0 14.883-12.065 26.95-26.946 26.95"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA4F57",
    d: "M228 63.3c0 14.883-12.065 26.95-26.946 26.95s-26.946-12.067-26.946-26.95z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h228v134H0z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEndHeader);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/end-header.6cbdd72d7b0825d9f2878e08675e59a3.svg";